import React from "react";
import { TextField, TextFieldProps } from "../TextField";
import { Caption } from "../Typography";
// eslint-disable-next-line cohere-react/no-mui-styled-import
import { styled } from "@material-ui/core";
import { colorsLight } from "../../themes";
import { useFeature } from "../../components";
import { calculateFleschKincaidGradeLevel } from "../../util/fleschKincaidUtils";

interface DenialLetterTextBoxWithGradeLevelProps extends TextFieldProps {
  denialReadingLevelConfigEnabled: boolean;
}

export function DenialLetterTextBoxWithGradeLevel({
  denialReadingLevelConfigEnabled,
  ...props
}: DenialLetterTextBoxWithGradeLevelProps) {
  const denialLetterReadingLevelFeatureEnabled = useFeature("denialLetterReadingLevel");
  const denialLetterReadingLevelEnabled = Boolean(
    denialLetterReadingLevelFeatureEnabled && denialReadingLevelConfigEnabled
  );
  const shouldDisplayGradeLevel =
    denialLetterReadingLevelEnabled && props.value && String(props.value).trim().length > 0;
  return (
    <div
      style={{
        marginBottom: "24px",
      }}
    >
      <DenialLetterTextBox {...props} />
      <>{shouldDisplayGradeLevel && <Caption>{calculateFleschKincaidGradeLevel(props.value as string)}</Caption>}</>
    </div>
  );
}

// eslint-disable-next-line cohere-react/no-mui-styled-import
const DenialLetterTextBox = styled(TextField)(({ theme }) => ({
  "& .MuiFilledInput-root": {
    paddingTop: "10px",
    borderColor: colorsLight.gray.divider,
    backgroundColor: colorsLight.background.card,
    "&:hover,&.Mui-focused": {
      backgroundColor: colorsLight.background.card,
    },
    alignItems: "inherit",
  },
  "& .MuiInputBase-input": {
    color: colorsLight.font.main,
  },
}));
